import React, { createContext, useEffect, useState } from 'react';
import useWindowSize from '@polestar/component-warehouse-react/hooks/useWindowSize';
import MediaQueries from '@polestar/component-warehouse-react/tokens/media-queries/MediaQueries';
import DeviceTypes from '@polestar/component-warehouse-react/tokens/device-types/DeviceTypes';
const initialQueryMatches = {
    [DeviceTypes.mobile]: false,
    [DeviceTypes.tablet]: false,
    [DeviceTypes.desktop]: false,
    [DeviceTypes.desktopWide]: false,
};
export const MediaQueryContext = createContext({
    querySizes: [],
    queryMatches: initialQueryMatches,
    name: 'mobile',
});
/**
 * @todo When the MediaQueries have removed the `@media ` prefix, make sure to remove the
 *   calls to replace() here.
 */
const deviceQueries = [
    {
        name: DeviceTypes.mobile,
        query: MediaQueries.mobile.replace('@media ', ''),
    },
    {
        name: DeviceTypes.tablet,
        query: MediaQueries.tablet.replace('@media ', ''),
    },
    {
        name: DeviceTypes.desktop,
        query: MediaQueries.desktop.replace('@media ', ''),
    },
    {
        name: DeviceTypes.desktopWide,
        query: MediaQueries.desktopWide.replace('@media ', ''),
    },
].reverse();
/**
 * @todo I think this context can be simplified by returning just a single matching device type or
 *   something similar.
 */
export const MediaQueryProvider = ({ children }) => {
    const { innerWidth } = useWindowSize();
    const [sizes, setSizes] = useState([]);
    const [matches, setMatches] = useState(initialQueryMatches);
    useEffect(() => {
        var _a;
        const newSizes = [];
        const newMatches = {
            mobile: false,
            tablet: false,
            desktop: false,
            desktopWide: false,
        };
        for (const deviceQuery of deviceQueries) {
            if ((_a = window === null || window === void 0 ? void 0 : window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, deviceQuery.query).matches) {
                newSizes.push(deviceQuery.name);
                newMatches[deviceQuery.name] = true;
                break;
            }
        }
        setSizes(newSizes);
        setMatches(newMatches);
    }, [innerWidth]);
    const value = { querySizes: sizes, queryMatches: matches, name: sizes[0] };
    return React.createElement(MediaQueryContext.Provider, { value: value }, children);
};
